import { z } from 'zod'

const emailField = z
  .string()
  .trim()
  .email()
  .optional()
  .or(z.literal(''))
  .transform((v) => (v ? v : undefined))

const langField = z.enum(['vi', 'en']).default('vi')

export const requestSchema = z.object({
  kind: z.enum(['module', 'course']),
  title: z.string().trim().min(3).max(120),
  description: z.string().trim().min(10).max(1000),
  email: emailField,
  lang: langField,
  turnstileToken: z.string().min(1),
})

export const feedbackSchema = z.object({
  type: z.enum(['lesson', 'course', 'doc']),
  slug: z.string().trim().min(1).max(200),
  message: z.string().trim().min(5).max(1000),
  email: emailField,
  lang: langField,
  turnstileToken: z.string().min(1),
})

export type RequestInput = z.infer<typeof requestSchema>
export type FeedbackInput = z.infer<typeof feedbackSchema>
